import { css } from 'styled-components'

const transparentOutlinedButtonTemplate = () => css`
  background: transparent;
  color: var(--sl-fg-muted);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  font-weight: var(--sl-font-weight-regular);

  min-width: unset;
  height: auto;
  padding: var(--sl-space-2) var(--sl-space-3);

  &:not(:disabled) {
    &:hover {
      border: var(--sl-border-base-strong);
    }
  }

  &.active {
    color: var(--primary);
    border-color: var(--primary);
    background: color-mix(in srgb, var(--primary) 10%, transparent);

    &:not(:disabled) {
      &:hover {
        border-color: var(--primary);
        background: color-mix(in srgb, var(--primary) 20%, transparent);
      }
    }
  }

  &:disabled {
    color: var(--sl-fg-base-disabled);
    cursor: not-allowed;
  }
`

export default transparentOutlinedButtonTemplate
